export const SCS_JavaScriptEcosystemSlides = require('./scs-web-terrible').default;
export const SKS_TameJavaScriptEcosystemSlides = require('./sks-tame-js').default;

export default {
  SCS_JavaScriptEcosystemSlides,
  SKS_TameJavaScriptEcosystemSlides,
};



// WEBPACK FOOTER //
// ./src/presentations/modern-javascript/index.js